// extracted by mini-css-extract-plugin
module.exports = {"modals":"Popups_modals__Gxi6O","close_button":"Popups_close_button__xS5bP","speak_with_expert":"Popups_speak_with_expert__rBXiQ","no_select_input":"Popups_no_select_input__aDTFf"};